import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

const AUTH_FLOW_PARAMS = ['code', 'state', 'error', 'token_id', 'user_id', 'mcp_transaction'];

export const loginRedirectGuard: CanActivateFn = (route) => {
  const { returnUrl, ...queryParams } = route.queryParams;
  // el callback SSO y el autologin por token aterrizan en /login y deben poder reemplazar la sesión
  if (AUTH_FLOW_PARAMS.some((param) => param in queryParams)) return true;
  if (!localStorage.getItem('currentJWT')) return true;

  const router = inject(Router);
  if (!returnUrl) return router.parseUrl('/dashboard');

  const target = returnUrl.startsWith('/') ? returnUrl : `/${returnUrl}`;
  if (/^\/[/\\]/.test(target)) return router.parseUrl('/dashboard');

  const tree = router.parseUrl(target);
  tree.queryParams = { ...tree.queryParams, ...queryParams };
  return tree;
};
